import React from "react";
import { Outlet } from "react-router-dom";
import ThemeProvider from "../theme/ThemeProvider";
import RouteThemePicker from "../components/RouteThemePicker";

export default function RootLayout() {
  return (
    <ThemeProvider>
      <Outlet />
      <RouteThemePicker />
    </ThemeProvider>
  );
}
